import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"font-size":"10px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("\n        Filter current: ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("\n      ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_DisplayTypesButtonGroup = _resolveComponent("DisplayTypesButtonGroup")!
  const _component_CardItemProxy = _resolveComponent("CardItemProxy")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    ref: "listPage",
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    state: _ctx.state
  }, {
    filters: _withCtx(() => [
      (_ctx.debug)
        ? (_openBlock(), _createElementBlock("pre", _hoisted_1, [
            _createTextVNode("        Interactions: " + _toDisplayString(_ctx.hasInteractions), 1),
            _hoisted_2,
            _createTextVNode("\n        WS: " + _toDisplayString(_ctx.workspaceModule.items), 1),
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createTextVNode("\n        MKey: " + _toDisplayString(_ctx.pageVM.moduleKey), 1),
            _hoisted_7,
            _createTextVNode("\n        " + _toDisplayString(_ctx.module.filter.current), 1),
            _hoisted_8,
            _createTextVNode("\n        Current: " + _toDisplayString(_ctx.currentItem) + "\n        Name " + _toDisplayString(_ctx.module.name) + " ", 1),
            _hoisted_9,
            _createTextVNode("\n        " + _toDisplayString(_ctx.pageVM.state), 1),
            _hoisted_10,
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_FilterSection, {
        key: _ctx.pageVM.moduleKey,
        filter: _ctx.module.filter,
        "scheme-small": _ctx.smallFilterLayout,
        "scheme-large": _ctx.bigFilterLayout,
        "has-report": "",
        "has-filter-manager": "",
        "has-pinned-fields": ""
      }, {
        small: _withCtx(() => [
          (_ctx.dataAssetsModule.cardTypeButtonItems.length > 1)
            ? (_openBlock(), _createBlock(_component_NButtonGroup, {
                key: 0,
                items: _ctx.dataAssetsModule.cardTypeButtonItems,
                modelValue: _ctx.state.cardType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.cardType) = $event)),
                "init-value-on-empty": ""
              }, null, 8, ["items", "modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["filter", "scheme-small", "scheme-large"]))
    ]),
    statistic: _withCtx(() => [
      _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
      _hoisted_12,
      _createVNode(_component_SortDropdown, {
        items: _ctx.sortTypes,
        modelValue: _ctx.module.filter.current.ordering,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
      }, null, 8, ["items", "modelValue"]),
      _hoisted_13,
      (_ctx.modelAcl.add)
        ? (_openBlock(), _createBlock(_component_NButton, {
            key: 0,
            icon: "add",
            onClick: _ctx.addNew
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cards.add_new', 'f')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _hoisted_14,
      _createVNode(_component_DisplayTypesButtonGroup, {
        modelValue: _ctx.state.displayType,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.displayType) = $event))
      }, null, 8, ["modelValue"])
    ]),
    items2: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isShort ? 'n-page__tiles n-page__tiles-compensation-5' : 'n-page__rows')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.module.items, (item) => {
          return (_openBlock(), _createBlock(_component_CardItemProxy, {
            "data-id": item.id,
            key: item.id,
            display: _ctx.intersectionResultItem?.displayItemsMap[item.id] ?? false,
            type: _ctx.state.cardType,
            item: item,
            "model-acl": _ctx.modelAcl,
            displayType: _ctx.state.displayType,
            selected: !!_ctx.sidebarModule.getItem(_ctx.pageSidebarType, item.id),
            opened: _ctx.getIsCardOpened(item),
            showMatchedConnections: item.has_matched_case_cluster && _ctx.isShowConnections,
            showRelatedConnections: item.has_related_case_cluster && _ctx.isShowConnections,
            showInteractions: _ctx.hasInteractions,
            onSelect: () => _ctx.sidebarModule.addItemAndOpen(_ctx.pageSidebarType, item),
            onAction: (v) => _ctx.actionHandler(item.id, v, item),
            enabledFields: _ctx.smallFilterFields,
            "onUpdate:enabledFields": _cache[3] || (_cache[3] = (v) => _ctx.setSmallFilterFields(v))
          }, null, 8, ["data-id", "display", "type", "item", "model-acl", "displayType", "selected", "opened", "showMatchedConnections", "showRelatedConnections", "showInteractions", "onSelect", "onAction", "enabledFields"]))
        }), 128))
      ], 2)
    ]),
    _: 1
  }, 8, ["onUpdate:scrollBottom", "state"]))
}